// Sidebar configuration — centralized control for all width values
const SIDEBAR_CONFIG = {
  // Desktop (md and up) widths
  desktop: {
    expanded: 232,  // Width in pixels when expanded
    collapsed: 70,  // Width in pixels when collapsed
  },
  // Mobile (below md) width
  mobile: {
    temporary: 280, // Temporary drawer width on mobile
  },
};

export default SIDEBAR_CONFIG;
